import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedName from 'I18n/components/FormattedName';
import { Small } from 'foundations-components/transitional/components/Small';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Avatar } from 'avatar-components';
import { ApprovalStepStatus } from '../../types';
import { ApprovalStepStatusText } from '../sidebar/ApprovalStepStatusText';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { SuperAdminStatusTag } from '../common/SuperAdminStatusTag';
import { WarningIcon } from 'foundations-assets/icons/components/WarningIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ApprovalEditPanelTableCheckboxRow = ({
  approver,
  changeCheckbox,
  checkboxIsApproved,
  checkboxIsDisabled,
  checkboxIsRequester,
  checkboxIsSelected,
  isSuperAdmin,
  showInvalidApproverWarning
}) => {
  const testId = `approval-checkbox-row-${approver.ownerId}`;
  return /*#__PURE__*/_jsx("tr", {
    "data-test-id": testId,
    children: /*#__PURE__*/_jsx("td", {
      colSpan: 2,
      children: /*#__PURE__*/_jsxs(TFlex, {
        alignItems: "center",
        justifyContent: "space-between",
        children: [/*#__PURE__*/_jsx(Tooltip, {
          disabled: !checkboxIsDisabled,
          placement: "left",
          title: checkboxIsRequester ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "productApprovals.ApprovalEditPanel.tooltipRequesterDisabled"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "productApprovals.ApprovalEditPanel.tooltipApproverApproved"
          }),
          children: /*#__PURE__*/_jsx(Checkbox, {
            alignment: "center",
            checked: checkboxIsSelected,
            "data-test-id": `edit-panel-checkbox-${approver.email}`,
            disabled: checkboxIsDisabled,
            onChange: () => changeCheckbox(approver.ownerId),
            children: /*#__PURE__*/_jsxs(TFlex, {
              alignItems: "center",
              children: [/*#__PURE__*/_jsx(Avatar, {
                marginInline: "300",
                hubSpotUserEmail: approver.email
              }), /*#__PURE__*/_jsxs(TFlex, {
                direction: "column",
                children: [/*#__PURE__*/_jsxs(TFlex, {
                  align: "center",
                  children: [/*#__PURE__*/_jsx(FormattedName, {
                    givenName: approver.firstName,
                    familyName: approver.lastName
                  }), isSuperAdmin && /*#__PURE__*/_jsx(SuperAdminStatusTag, {}), showInvalidApproverWarning && /*#__PURE__*/_jsx(Tooltip, {
                    title: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "productApprovals.ApprovalUserFormattedName.scopeLost.tooltip"
                    }),
                    children: /*#__PURE__*/_jsxs(TFlex, {
                      align: "center",
                      marginInlineStart: "300",
                      "data-test-id": "approval-user-scope-lost-warning",
                      children: [/*#__PURE__*/_jsx(WarningIcon, {
                        color: "fill-caution-default"
                      }), /*#__PURE__*/_jsx(Small, {
                        marginInlineStart: "100",
                        children: /*#__PURE__*/_jsx(FormattedMessage, {
                          message: "productApprovals.ApprovalUserFormattedName.scopeLost.text"
                        })
                      })]
                    })
                  })]
                }), /*#__PURE__*/_jsx(Small, {
                  use: "help",
                  children: approver.email
                })]
              })]
            })
          })
        }), checkboxIsApproved && /*#__PURE__*/_jsx(ApprovalStepStatusText, {
          approvalStepStatus: ApprovalStepStatus.APPROVED
        })]
      })
    })
  }, approver.ownerId);
};